module.exports = __webpack_public_path__ + "static/media/loading-gear.47b49276.gif";